module.exports = __webpack_public_path__ + "static/media/image_60.136dfea4.png";